import type { Board } from "../board";
import type { Direction } from "../direction";
import { cycleDirection, directionDelta } from "../direction";
import type { Player } from "../player";
import { AirBlastShot } from "../projectiles/airBlastShot";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";

export class AirBlast extends Weapon {
	static key = "AirBlast";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_WHITE;
	}

	override getMuzzleFlashCount(): number {
		return 12;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_SOLIDIFIER));
		for (let cycle = -1; cycle <= 1; cycle++) {
			const spawnDir = cycleDirection(direction, cycle);
			const spawnPos = this.owner.xy.add(directionDelta(spawnDir));
			const maxRange = cycle === 0 ? 7 : 3;
			const shot = new AirBlastShot(spawnPos, direction, maxRange);
			this.shotProjectile(board, shot);
		}
	}

	static deserialize(data: any, owner: Player): AirBlast {
		const gun = new AirBlast(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
